import { Instructions, InstructionsFetchOptions } from "../models/types";
import queryClient, { QueryKey } from "../state/QueryStore";
import { ListResponse } from "../utilities/ApiResponseHelper";
import {
  httpDeleteAuthenticated,
  httpGetAuthenticated,
  httpPatchAuthenticated,
  httpPostAuthenticated,
} from "./ApiService";

const endpoints = {
  instructions: () => "/instructions",
  instruction: (id: string) => `/instructions/${id}`,
};

export const getInstructions = (params: InstructionsFetchOptions) => {
  return httpGetAuthenticated<ListResponse<Instructions>>(endpoints.instructions(), {
    params,
  });
};

export const getInstruction = (id: string) => {
  return httpGetAuthenticated<Instructions>(endpoints.instruction(id));
};

export const addInstruction = async (payload: {
  type: string;
  parent_object_id?: string | null;
  instructions: string;
}) => {
  const { data } = await httpPostAuthenticated(endpoints.instructions(), payload);
  queryClient.invalidateQueries({ queryKey: [QueryKey.Instructions] });
  return data;
};

export const editInstruction = async (
  id: string,
  payload: {
    type?: string;
    parent_object_id?: string | null;
    instructions?: string;
  }
) => {
  const { data } = await httpPatchAuthenticated(endpoints.instruction(id), payload);
  queryClient.invalidateQueries({ queryKey: [QueryKey.Instructions] });
  return data;
};

export const deleteInstruction = async (id: string) => {
  const resp = await httpDeleteAuthenticated(endpoints.instruction(id));
  queryClient.invalidateQueries({ queryKey: [QueryKey.Instructions] });
  return resp;
};
